import axiosInstance from '../../../helpers/backend_helper';

const getAllAmazonBooks = async () => {
  try {
    const response = await axiosInstance.get('books');
    return response.data;
  } catch (error) {
    console.error('Error fetching all Amazon books:', error);
    throw error;
  }
};

export default getAllAmazonBooks;
